import { createTriggerResource, createMutation } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { checksRepository } from '~/repositories/checks';
import { ownerRepository } from '~/repositories/ownersRepository';
import type {
  CreateOwnerTransferDto,
  GetOwnerContributionsParams,
  GetOwnerDistributionsParams,
  GetOwnerTransfersParams,
} from '~/swagger/portal/Api';

export const [OwnerTransfersContextProvider, useOwnerTransfers] = createMagicDoorContext('OwnerTransfers', () => {
  const [ownerContributionDetails, setContributionDetails] = createTriggerResource((id: string) => {
    return ownerRepository.getOwnerContributionDetails(id);
  });

  const [ownerDistributionDetails, setDistributionDetails] = createTriggerResource((id: string) => {
    return ownerRepository.getOwnerDistributionDetails(id);
  });

  const [ownerTransferDetails, setTransferDetails] = createTriggerResource((id: string) => {
    return ownerRepository.getOwnerTransferDetails(id);
  });

  const [ownerContributions, setContributionsFilter, contributionsActions] = createTriggerResource(
    (filter: GetOwnerContributionsParams) => {
      return ownerRepository.getOwnerContributions(filter);
    }
  );

  const [ownerContributionRequests, setContributionRequestsFilter, contributionRequestsActions] = createTriggerResource(
    (filter: GetOwnerContributionsParams) => {
      return ownerRepository.getOwnerContributionRequests(filter);
    }
  );

  const [ownerDistributions, setDistributionsFilter, distributionsActions] = createTriggerResource(
    (filter: GetOwnerDistributionsParams) => {
      return ownerRepository.getOwnerDistributions(filter);
    }
  );

  const [ownerTransfers, setTransfersFilter, transfersActions] = createTriggerResource((filter: GetOwnerTransfersParams) => {
    return ownerRepository.getOwnerTransfers(filter);
  });

  const deleteOwnerContribution = createMutation(async (id: string) => {
    return ownerRepository.deleteOwnerContribution(id);
  });

  const deleteOwnerContributionRequest = createMutation(async (id: string) => {
    return ownerRepository.deleteOwnerContributionRequest(id);
  });

  const deleteOwnerDistribution = createMutation(async (id: string) => {
    return ownerRepository.deleteOwnerDistribution(id);
  });

  const deleteOwnerTransfer = createMutation(async (id: string) => {
    return ownerRepository.deleteOwnerTransfers(id);
  });

  const addOwnerTransfer = createMutation(async (payload: CreateOwnerTransferDto) => {
    await ownerRepository.postOwnerTransfers(payload);
  });

  const getOwnerAvailableBalance = createMutation(async (ownerId: string, propertyId: string) => {
    return await ownerRepository.getOwnerAvailableBalance(ownerId, propertyId);
  });

  const getCheck = createMutation(async (id: string) => {
    return await checksRepository.getCheck(id);
  });

  return {
    ownerContributions,
    ownerContributionRequests,
    ownerDistributions,
    ownerTransfers,
    setContributionsFilter,
    setContributionRequestsFilter,
    setDistributionsFilter,
    setTransfersFilter,
    contributionsActions,
    contributionRequestsActions,
    distributionsActions,
    transfersActions,
    deleteOwnerContribution,
    deleteOwnerContributionRequest,
    deleteOwnerDistribution,
    deleteOwnerTransfer,
    addOwnerTransfer,
    ownerContributionDetails,
    ownerDistributionDetails,
    ownerTransferDetails,
    setContributionDetails,
    setDistributionDetails,
    setTransferDetails,
    getOwnerAvailableBalance,
    getCheck,
  };
});
